import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const ContactUs = () => {
  const [form, setForm] = useState({ firstName: '', lastName: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Submitted Data:", form);
    // TODO: replace with actual backend/API call or Supabase form collection
    setSubmitted(true);
  };

  return (
    <>
      <Navbar />
      <div className="max-w-6xl mx-auto px-6 py-12 text-gray-800">
        <div className="grid md:grid-cols-2 gap-12 items-start">
          <div>
          <h1 className="text-4xl font-bold text-center mb-4 bg-gradient-to-r from-slate-400 via-zinc-400 to-stone-800 text-transparent bg-clip-text">
          Contact Us
        </h1>
            <p className="text-gray-600 mb-4">
              Need to get in touch with us? Please fill out the form with your inquiry.
            </p>
            <p className="text-red-600 font-medium">AMG Corp Subsidiary.</p>
          </div>

          <form onSubmit={handleSubmit} className="bg-gray-50 p-8 rounded-xl shadow-md w-full">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <div>
                <label className="block text-sm font-medium">First name*</label>
                <input
                  name="firstName"
                  type="text"
                  value={form.firstName}
                  onChange={handleChange}
                  required
                  className="w-full mt-1 px-4 py-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium">Last name</label>
                <input
                  name="lastName"
                  type="text"
                  value={form.lastName}
                  onChange={handleChange}
                  className="w-full mt-1 px-4 py-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
                />
              </div>
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium">Email*</label>
              <input
                name="email"
                type="email"
                value={form.email}
                onChange={handleChange}
                required
                className="w-full mt-1 px-4 py-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
              />
            </div>

            <div className="mb-6">
              <label className="block text-sm font-medium">What can we help you with?</label>
              <textarea
                name="message"
                rows="4"
                value={form.message}
                onChange={handleChange}
                className="w-full mt-1 px-4 py-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
              ></textarea>
            </div>

            <button
              type="submit"
              className="w-full bg-purple-600 text-white py-2 rounded-md font-semibold hover:bg-purple-700 transition"
            >
              Submit
            </button>
            {submitted && <p className="mt-4 text-green-600">Thank you! Your message has been submitted.</p>}
          </form>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ContactUs;